import Slider from '../services/sliderService';

export default function newsRelatedSlider() {
    const elements = document.querySelectorAll('.js-news-related-slider');

    function createNewsRelatedSlider(element, wrapper) {
        const options = {
            slideVisibleClass: 'news-related-slider__slider-item--visible',
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1044: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
            wrapperElement: wrapper,
        };

        return new Slider(element, options);
    }

    elements.forEach((element) => {
        const wrapper = element.closest('.news-related-slider');

        createNewsRelatedSlider(element, wrapper);
    });
}
